import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import img from "./img/ChatboatImg.gif";
import Header from "../../../Header/Header";
import TextSection from "./TextSection";
import FeaturePlans from "./FeaturePlans";
import CardMenu from "./CardMenu";
import CompanySection from "./CompanySection";
import CardContent from "./CardContent";
import TextSection1 from "./TextSection1";
import CardContent1 from "./CardContent1";
import AuthorSection from "./AuthorSection";
import UseCaseSection from "./UseCaseSection";
import CardMenuSection from "./CardMenuSection ";
import FooterSection from "../FooterSection";
import TestimonialsSection from "./TestimonialSection";
import hero from "./img/hero.png";
import CircleIcon from "@mui/icons-material/Circle";

const listItems = [
  "Build Multiple dynamic WhatsApp Chatbots easily with a drag-and-drop Interface.",
  "Enable Multiple WhatsApp Chatbots in one account.",
  "Automate up to <strong>80% of customer queries</strong> without writing a single line of code.",
];

const WhatsAppChatboat = () => {
  return (
    <>
      <Header />
      <Box
        sx={{
          px: { xs: 2, md: 10 },
          py: { xs: 4, md: 8 },
          display: "flex",
          justifyContent: "center",
          backgroundImage: `url('bg2.svg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "80vh",
        }}
      >
        <Grid
          container
          spacing={{ xs: 2, lg: 4 }}
          alignItems="center"
          sx={{
            width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
          }}
        >
          {/* Left Content */}
          <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
            <Typography
              sx={{
                fontSize: { xs: "2.4rem", md: "3.5rem" },
              }}
              fontWeight="bold"
              gutterBottom
            >
              Create No-code <br />
              <span style={{ color: "#25d366" }}>WhatsApp Chatbots</span> <br />
              in Minutes
            </Typography>

            <ul
              style={{
                listStyleType: "disc",
                paddingLeft: "20px",
                color: "#666",
              }}
            >
              {listItems.map((text, index) => (
                <li key={index}>
                  <Typography
                    variant="body1"
                    fontSize="17px"
                    dangerouslySetInnerHTML={{ __html: text }}
                  />
                </li>
              ))}
            </ul>

            <Typography variant="body2" color="text.secondary" mt={3}>
              <FlashOnIcon
                sx={{
                  fontSize: "1.3rem",
                  verticalAlign: "middle",
                  color: "#ff9100",
                }}
              />{" "}
              Powered by <strong>Official WhatsApp Business API</strong>
            </Typography>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={4}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#25d366",
                  "&:hover": { backgroundColor: "#00b34a" },
                  px: 3,
                }}
              >
                Start for FREE →
              </Button>
              <Button
                variant="outlined"
                sx={{
                  borderColor: "#000",
                  color: "#000",
                  px: 3,
                  "&:hover": {
                    borderColor: "#000",
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                Book a Demo
              </Button>
            </Stack>
          </Grid>

          {/* RightSide Image */}
          <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
            <Box
              component="img"
              src={hero}
              alt="WhatsApp Chatbot Flow"
              sx={{
                width: "100%",
                maxHeight: "auto",
                // borderRadius: 2,
                // boxShadow: 2,
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* <TextSection /> */}
      <CardMenu />
      <FeaturePlans />
      <CardContent />
      <TextSection1 />
      <CompanySection />
      <CardContent1 />
      <TestimonialsSection />
      {/* <AuthorSection /> */}
      {/* <UseCaseSection /> */} 
      {/* <CardMenuSection /> */}
      <FooterSection />
    </>
  );
};

export default WhatsAppChatboat;
